import { render } from "./LanguageSelect.vue?vue&type=template&id=85612390&scoped=true&ts=true"
import script from "./LanguageSelect.vue?vue&type=script&lang=ts"
export * from "./LanguageSelect.vue?vue&type=script&lang=ts"

import "./LanguageSelect.vue?vue&type=style&index=0&id=85612390&scoped=true&lang=css"

import exportComponent from "../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85612390"]])

export default __exports__